export default {
  50: "Vervallen",
  91: "Niet doorgegaan - BKR",
  92: "Niet doorgegaan - inkomen",
  93: "Niet doorgegaan - waarde onderpand",
  94: "Niet doorgegaan - verzoek klant",
};
